<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.099"
    height="20.099"
    viewBox="0 0 20.099 20.099">
    <g id="image-onrow" transform="translate(0.75 0.75)">
      <path
        id="Path_524"
        data-name="Path 524"
        d="M3,6.72A3.72,3.72,0,0,1,6.72,3H17.879A3.72,3.72,0,0,1,21.6,6.72V17.879a3.72,3.72,0,0,1-3.72,3.72H6.72A3.72,3.72,0,0,1,3,17.879Z"
        transform="translate(-3 -3)"
        fill="transparent"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5" />
      <path
        id="Path_525"
        data-name="Path 525"
        d="M13.65,11.325A2.325,2.325,0,1,1,11.325,9,2.325,2.325,0,0,1,13.65,11.325Z"
        transform="translate(-5.28 -5.281)"
        fill="transparent"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5" />
      <path
        id="Path_526"
        data-name="Path 526"
        d="M16.929,18.558,9,27.28H20.283a3.6,3.6,0,0,0,3.6-3.6V23.56a1.184,1.184,0,0,0-.456-.921l-3.748-4.087a1.86,1.86,0,0,0-2.747.006Z"
        transform="translate(-5.28 -8.682)"
        fill="transparent"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5" />
    </g>
  </svg>
</template>
